module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-2 d-none d-lg-block"
  }, [(!_vm.isFetching.auction) ? _c('b-jumbotron', {
    staticClass: "p-4 h-100"
  }, [_c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching.previousItem
    }
  }), _vm._v(" "), (!_vm.isFetching.previousItem && _vm.previousItem) ? _c('div', [(_vm.item.previous_auction_order_number) ? _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "w-100 mb-4",
    attrs: {
      "variant": "outline-primary",
      "disabled": _vm.isFetching.item,
      "size": "lg",
      "title": _vm.$t('item.previousItem')
    },
    on: {
      "click": function($event) {
        return _vm.setPage(_vm.item.previous_auction_order_number)
      }
    }
  }, [(_vm.isFetching.item) ? _c('fa-icon', {
    attrs: {
      "icon": "spinner",
      "fixed-width": "",
      "spin": ""
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.$t('item.previous')))])], 1) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('item.auctionOrderNumber')) + " " + _vm._s(_vm.item.previous_auction_order_number))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.previousItem.seller.code) + "-" + _vm._s(_vm.previousItem.number))]), _vm._v(" " + _vm._s(_vm.previousItem.title) + "\n\t\t\t\t")]), _vm._v(" "), (_vm.previousItem.media && _vm.previousItem.media.length) ? _c('div', {
    staticClass: "thumbnail",
    style: ({
      backgroundImage: ("url(" + (_vm.previousItem.media[0].url) + ")")
    })
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isFetching.item && !_vm.isFetching.previousItem && _vm.previousItem == false) ? _c('h5', {
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('item.noPreviousItem')) + "\n\t\t\t")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-8"
  }, [_c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching.auction
    }
  }), _vm._v(" "), (_vm.error) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.error) + "\n\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFetching.auction),
      expression: "!isFetching.auction"
    }]
  }, [_c('b-jumbotron', {
    staticClass: "p-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "pull-right",
    attrs: {
      "to": {
        name: 'auction'
      },
      "variant": "outline-secondary",
      "title": _vm.$t('auction.stopLive')
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": "reply",
      "fixed-width": ""
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "display-4"
  }, [_c('fa-icon', {
    attrs: {
      "fixed-width": "",
      "icon": "gavel"
    }
  }), _vm._v(" " + _vm._s(_vm.auction.title))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('auction-category', {
    attrs: {
      "selected": _vm.item.category,
      "internal-search": true,
      "deletable": false,
      "label": _vm.$t('common.category')
    },
    on: {
      "update:category": _vm.changeCategory
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.goTo($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('item.gotoAuctionOrderNumber')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "autocomplete": "off",
      "placeholder": _vm.$t('item.auctionOrderNumber'),
      "step": "1"
    },
    model: {
      value: (_vm.goToNumber),
      callback: function($$v) {
        _vm.goToNumber = $$v
      },
      expression: "goToNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-form-group', [_c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "primary",
      "disabled": _vm.goToNumber == '',
      "type": "submit",
      "block": "",
      "title": _vm.$t('item.gotoAuctionOrderNumber')
    }
  }, [_c('fa-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isGoingTo),
      expression: "!isGoingTo"
    }],
    attrs: {
      "icon": "arrow-right",
      "fixed-width": ""
    }
  }), _vm._v(" "), _c('fa-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGoingTo),
      expression: "isGoingTo"
    }],
    attrs: {
      "icon": "spinner",
      "fixed-width": "",
      "spin": ""
    }
  })], 1)], 1)], 1)])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-jumbotron', {
    staticClass: "p-4 h-100"
  }, [_c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching.item
    }
  }), _vm._v(" "), (!_vm.isFetching.item && _vm.item) ? _c('div', [_c('div', {
    staticClass: "row mb-4"
  }, [(_vm.item.media && _vm.item.media.length) ? _c('div', {
    staticClass: "col-4"
  }, [(_vm.item.media && _vm.item.media.length) ? _c('div', {
    staticClass: "thumbnail",
    style: ({
      backgroundImage: ("url(" + (_vm.item.media[0].url) + ")")
    })
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-button-group', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": _vm.$t('common.seller'),
      "to": {
        name: 'auctionSeller',
        params: {
          personId: _vm.item.seller_id
        }
      }
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": "user",
      "fixed-width": ""
    }
  })], 1), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": _vm.$t('item.edit'),
      "to": {
        name: 'itemEdit',
        params: {
          itemId: _vm.item.id
        }
      }
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": "edit",
      "fixed-width": ""
    }
  })], 1)], 1), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('item.auctionOrderNumber')) + " "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.item.auction_order_number))])]), _vm._v(" "), _c('h3', [_c('strong', [_vm._v(_vm._s(_vm.item.seller.code) + "-" + _vm._s(_vm.item.number))]), _vm._v(" " + _vm._s(_vm.item.title))]), _vm._v(" "), _c('p', [(_vm.item.target_price_1) ? _c('span', [_vm._v(_vm._s(_vm.$t('item.targetprice', {
    number: 1
  })) + ": € " + _vm._s(Math.round(_vm.item.target_price_1))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.item.target_price_2) ? _c('span', [_vm._v(_vm._s(_vm.$t('item.targetprice', {
    number: 2
  })) + ": € " + _vm._s(Math.round(_vm.item.target_price_2))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.item.limit) ? _c('span', [_vm._v(_vm._s(_vm.$t('item.limit')) + ": € " + _vm._s(_vm.item.limit))]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.item.description) + "\n\t\t\t\t\t\t\t\t\t")])], 1)]), _vm._v(" "), (_vm.formError.errors) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, _vm._l((_vm.formError.errors), function(errors, i) {
    return _c('span', {
      key: i
    }, _vm._l((errors), function(error, j) {
      return _c('span', {
        key: (i + "-" + j)
      }, [_vm._v(_vm._s(error)), _c('br')])
    }), 0)
  }), 0) : _vm._e(), _vm._v(" "), _c('b-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('bid.price')))]), _vm._v(" "), _c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_vm._v("€")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "text-right",
    attrs: {
      "size": "lg",
      "type": "number",
      "step": "1",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.price),
      callback: function($$v) {
        _vm.$set(_vm.form, "price", $$v)
      },
      expression: "form.price"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('bid.bidNumber')))]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "lg",
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.bid_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "bid_number", $$v)
      },
      expression: "form.bid_number"
    }
  })], 1), _vm._v(" "), (_vm.item.bid) ? _c('div', {
    staticClass: "col-2"
  }, [_c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "w-100",
    attrs: {
      "variant": "outline-danger",
      "disabled": _vm.isDeleting,
      "size": "lg",
      "title": _vm.$t('bid.delete')
    },
    on: {
      "click": _vm.showDeleteModal
    }
  }, [(!_vm.isDeleting) ? _c('fa-icon', {
    attrs: {
      "icon": "trash",
      "fixed-width": ""
    }
  }) : _c('fa-icon', {
    attrs: {
      "icon": "spinner",
      "fixed-width": "",
      "spin": ""
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('delete-dialog-modal', {
    ref: "deleteModal",
    attrs: {
      "delete-name": _vm.$t('bid.deleteBidModal'),
      "isDeleting": _vm.isDeleting
    },
    on: {
      "confirm": _vm.deleteBid
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "w-100",
    attrs: {
      "variant": "primary",
      "disabled": _vm.isSubmitting,
      "type": "submit",
      "size": "lg",
      "title": _vm.$t('item.sell')
    }
  }, [(!_vm.isSubmitting) ? _c('fa-icon', {
    attrs: {
      "icon": "gavel",
      "fixed-width": ""
    }
  }) : _c('fa-icon', {
    attrs: {
      "icon": "spinner",
      "fixed-width": "",
      "spin": ""
    }
  })], 1)], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (!_vm.item && !_vm.isFetching.item) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_c('p', {
    staticClass: "p-0 m-0"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('item.noItemFoundForAuctionOrderNumber', {
    AuctionOrderNumber: _vm.auctionNumber
  })) + "\n\t\t\t\t\t\t\t")])]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.item) ? _c('div', {
    staticClass: "col-4"
  }, [_c('b-jumbotron', {
    staticClass: "p-4 h-100"
  }, [_c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching.pendingBids
    }
  }), _vm._v(" "), (!_vm.isFetching.pendingBids && _vm.pendingBids) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('common.pendingBids')))]), _vm._v(" "), (!_vm.pendingBids || _vm.pendingBids.length == 0) ? _c('p', {
    staticClass: "font-italic"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('pendingBid.noData')) + "\n\t\t\t\t\t\t\t")]) : _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('bid.bidNumber')))]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.$t('pendingBid.price')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pendingBids), function(bid, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_c('h3', [_vm._v(_vm._s(bid.pending_bid_number))])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("€ " + _vm._s(Math.round(bid.price)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('b-btn', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "primary",
        "disabled": _vm.isSubmitting,
        "size": "sm",
        "title": _vm.$t('item.usePrice')
      },
      on: {
        "click": function($event) {
          return _vm.setForm(bid.pending_bid_number, bid.price, true)
        }
      }
    }, [(!_vm.isSubmitting) ? _c('fa-icon', {
      attrs: {
        "icon": "gavel",
        "fixed-width": ""
      }
    }) : _c('fa-icon', {
      attrs: {
        "icon": "spinner",
        "fixed-width": "",
        "spin": ""
      }
    })], 1)], 1)])
  }), 0)])]) : _vm._e()], 1)], 1) : _vm._e()])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 d-none d-lg-block"
  }, [(!_vm.isFetching.auction) ? _c('b-jumbotron', {
    staticClass: "p-4 h-100"
  }, [_c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching.nextItem
    }
  }), _vm._v(" "), (!_vm.isFetching.nextItem && _vm.nextItem) ? _c('div', [(_vm.item.next_auction_order_number) ? _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "w-100 mb-4",
    attrs: {
      "variant": "outline-primary",
      "disabled": _vm.isFetching.item,
      "size": "lg",
      "title": _vm.$t('item.nextItem')
    },
    on: {
      "click": function($event) {
        return _vm.setPage(_vm.item.next_auction_order_number)
      }
    }
  }, [(_vm.isFetching.item) ? _c('fa-icon', {
    attrs: {
      "icon": "spinner",
      "fixed-width": "",
      "spin": ""
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.$t('item.next')))])], 1) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('item.auctionOrderNumber')) + " " + _vm._s(_vm.item.next_auction_order_number))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.nextItem.seller.code) + "-" + _vm._s(_vm.nextItem.number))]), _vm._v(" " + _vm._s(_vm.nextItem.title) + "\n\t\t\t\t")]), _vm._v(" "), (_vm.nextItem.media && _vm.nextItem.media.length) ? _c('div', {
    staticClass: "thumbnail",
    style: ({
      backgroundImage: ("url(" + (_vm.nextItem.media[0].url) + ")")
    })
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isFetching.item && !_vm.isFetching.nextItem && _vm.nextItem == false) ? _c('h5', {
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('item.noNextItem')) + "\n\t\t\t")]) : _vm._e()], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17f5f076"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/LiveAuction.vue
// module id = 1282
// module chunks = 1